import React, { useState } from 'react'

// mui
import TextField from '@mui/material/TextField'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

import InviteStaffFromPicker from '../dialogs/team/InviteStaffFromPicker'

// redux
import { useAppSelector, useAppDispatch } from '../../hooks'
import { getFundraisingAmbassadors, getFundraisingCampaigns } from '../../managers/redux/slices/fundraising'

import { FundraisingCampaign } from '../../API';
import InviteAmbassador from '../dialogs/fundraising/InviteAmbassador';

const FundraisingCampaignFilter = createFilterOptions<FundraisingCampaign>();

interface Props {
    onChange: (e: FundraisingCampaign | null) => void,
    value: FundraisingCampaign | null | undefined,
    label?: string,
    className?: string,
    disabled?: boolean
}

export default function FundraisingCampaignSelector(props: Props) {

    const [openFundraisingCampaignList, setOpenFundraisingCampaignList] = useState<boolean>(false)
    const [loadingFundraisingCampaigns, setLoadingFundraisingCampaigns] = useState<boolean>(false)
    const [showInviteFundraisingAmbassadorDialog, setShowInviteFundraisingAmbassadorDialog] = useState<boolean>(false)

    const dispatch = useAppDispatch()
    const fundraising = useAppSelector(state => state.fundraising)

    return (
        <>
            <Autocomplete
                disabled={props.disabled ? props.disabled : false}
                id="asynchronous-demo"
                sx={{ width: '100%' }}
                open={openFundraisingCampaignList}
                onOpen={async () => {
                    setLoadingFundraisingCampaigns(true)
                    setOpenFundraisingCampaignList(true)
                    if ((fundraising.ambassadors && fundraising.ambassadors.length == 0) || fundraising.ambassadors == null) {
                        await dispatch(getFundraisingCampaigns())
                    }
                    setLoadingFundraisingCampaigns(false)
                }}
                onClose={() => {
                    setOpenFundraisingCampaignList(false)
                }}
                onChange={(e, value) => {
                    if (typeof value !== 'string' && value && value.id == '00000000-0000-0000-0000-000000000000') {
                        setShowInviteFundraisingAmbassadorDialog(true)
                    } else if (typeof value !== 'string' && value && value.id != '00000000-0000-0000-0000-000000000000') {
                        props.onChange(value)
                    }
                }}
                value={props.value}
                isOptionEqualToValue={(option: FundraisingCampaign, value) => {
                    if (option.id == value.id) return true
                    else return false
                }}
                getOptionLabel={(option: FundraisingCampaign) => {
                    if (option.campaignName != null) return option.campaignName
                    else return 'Campaign Name Not Found'
                }}
                filterOptions={(options, params) => {
                    const filtered = FundraisingCampaignFilter(options, params);

                    return filtered;
                }}
                options={fundraising.campaigns ? fundraising.campaigns : []}
                loading={loadingFundraisingCampaigns}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder="Select a fundraising ambassador"
                        sx={{ width: '100%' }}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loadingFundraisingCampaigns ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                        label={props.label ? props.label : ''}
                        className={props.className ? props.className : ''}
                    />
                )}
            />
        </>
    )
}